module.exports = __webpack_public_path__ + "img/12.9970de73.png";